import type { Dictionary } from "./translations";

export const it: Dictionary = {
  "meta.title": "AgentBuck - Confronta i prezzi dei modelli IA",
  "meta.description": "Confronta i prezzi API dei principali modelli IA e stima i costi mensili in base al tuo consumo effettivo di token.",
  "nav.prices": "Prezzi dei modelli",
  "nav.calculator": "Calcolatore dei costi",
  "nav.providers": "Fornitori",
  "nav.guide": "Guida ai prezzi",
  "nav.method": "Metodologia",
  "aria.home": "Pagina iniziale di AgentBuck",
  "aria.language": "Seleziona lingua",
  "aria.navigation": "Navigazione principale",
  "aria.breadcrumb": "Percorso di navigazione",
  "aria.dark": "Attiva modalità scura",
  "aria.light": "Attiva modalità chiara",
  "title.dark": "Modalità scura",
  "title.light": "Modalità chiara",
  "hero.eyebrow": "Database dei prezzi API IA",
  "hero.title": "Trova il modello IA adatto al tuo budget",
  "hero.subtitle": "Confronta i prezzi di input, output e cache sulla stessa base, poi stima il costo mensile con il tuo consumo effettivo di token.",
  "stats.models": "Modelli confrontabili",
  "stats.providers": "Fornitori principali",
  "stats.updated": "Dati aggiornati",
  "common.loading": "Caricamento",
  "notice.snapshot": "I dati in tempo reale non sono disponibili. Sono visualizzati i dati locali del 7 settembre 2026.",
  "common.retry": "Riprova",
  "common.home": "Pagina iniziale",
  "common.models": "Modelli",
  "common.providers": "Fornitori",
  "common.from": "Da",
  "common.viewAll": "Vedi tutti",
  "common.backPricing": "Torna ai prezzi",
  "share.quick": "Condividi questa pagina",
  "share.kicker": "Condividi con il tuo team",
  "share.title": "Condividi questo confronto",
  "share.description": "Invia questa pagina con gli stessi modelli e le stesse ipotesi di utilizzo.",
  "share.copy": "Copia link",
  "share.copied": "Link copiato",
  "share.more": "Condividi",
  "share.openComparison": "Apri la pagina condivisa",
  "share.email": "E-mail",
  "calculator.title": "Calcolatore del costo mensile",
  "calculator.input": "Input mensile",
  "calculator.output": "Output mensile",
  "calculator.cache": "Quota di input in cache",
  "calculator.million": "milioni di token",
  "calculator.cheapest": "I 5 modelli più economici ora",
  "calculator.perMonth": "Stima / mese",
  "prices.title": "Prezzi dei modelli",
  "prices.subtitle": "API standard in tempo reale, USD per milione di token",
  "filter.open": "Filtri",
  "filter.search": "Cerca modelli o fornitori",
  "filter.clearSearch": "Cancella ricerca",
  "filter.provider": "Filtra per fornitore",
  "filter.allProviders": "Tutti i fornitori",
  "filter.sort": "Ordina modelli",
  "filter.favorite": "Salvati",
  "sort.monthly": "Costo mensile stimato",
  "sort.input": "Prezzo di input",
  "sort.output": "Prezzo di output",
  "sort.context": "Finestra di contesto",
  "sort.newest": "Uscite più recenti",
  "cap.reasoning": "Ragionamento",
  "cap.tools": "Chiamate a strumenti",
  "cap.vision": "Visione",
  "cap.structured": "Output strutturato",
  "cap.openWeights": "Pesi aperti",
  "results.found": "{count} modelli trovati",
  "results.source": "Tariffe normalizzate dai prezzi pubblicati. Consulta la documentazione del fornitore per verificarle.",
  "column.compare": "Confronta",
  "column.model": "Modello / fornitore",
  "column.input": "Input",
  "column.cached": "Input in cache",
  "column.output": "Output",
  "column.monthly": "Stima mensile",
  "column.context": "Contesto",
  "column.capabilities": "Ragion.  Strum.  Visione",
  "column.actions": "Azioni",
  "action.officialDocs": "Documentazione ufficiale",
  "action.addCompare": "Aggiungi al confronto",
  "action.removeCompare": "Rimuovi dal confronto",
  "action.addFavorite": "Salva modello",
  "action.removeFavorite": "Rimuovi modello salvato",
  "action.added": "Aggiunto",
  "context.suffix": "di contesto",
  "empty.title": "Nessun modello corrispondente",
  "empty.description": "Prova un'altra ricerca o rimuovi i filtri delle funzionalità.",
  "empty.clear": "Cancella filtri",
  "home.exploreKicker": "Esplora il catalogo",
  "home.exploreTitle": "Altri modi per confrontare i modelli IA",
  "home.providersTitle": "Esplora per fornitore",
  "home.providersBody": "Confronta tutti i modelli supportati di OpenAI, Anthropic, Google, DeepSeek, Alibaba e altri.",
  "home.guideTitle": "Leggi la guida ai prezzi",
  "home.guideBody": "Scopri come distribuzione dei token, cache dei prompt e fasce di contesto influenzano la fattura finale delle API.",
  "home.open": "Apri",
  "providers.kicker": "Elenco dei fornitori",
  "providers.title": "Fornitori di modelli IA",
  "providers.intro": "Consulta prezzi API normalizzati, limiti di contesto e funzionalità dei principali fornitori nel catalogo AgentBuck.",
  "providers.models": "{count} modelli",
  "providers.starting": "Tariffa di input minima",
  "providers.view": "Vedi fornitore",
  "provider.kicker": "Prezzi del fornitore",
  "provider.titleSuffix": "Prezzi API",
  "provider.description": "Confronta {count} modelli di {name} per prezzo di input, prezzo di output, finestra di contesto e funzionalità per la produzione.",
  "provider.cheapest": "Input più economico",
  "provider.largestContext": "Contesto massimo",
  "provider.updated": "Catalogo aggiornato",
  "model.kicker": "Dettaglio dei prezzi del modello",
  "model.title": "Prezzi API di {name}",
  "model.descriptionFallback": "Confronta tariffe API per token, limiti di contesto, funzionalità e costo mensile stimato di questo modello.",
  "model.input": "Input / 1 M di token",
  "model.cache": "Input in cache / 1 M",
  "model.output": "Output / 1 M di token",
  "model.context": "Finestra di contesto",
  "model.maxOutput": "Output massimo",
  "model.released": "Data di uscita",
  "model.updated": "Modello aggiornato",
  "model.estimateTitle": "La tua stima mensile",
  "model.estimateBody": "Basata su {input} M di input, {output} M di output e {cache}% di input in cache.",
  "model.relatedTitle": "Altri modelli di {provider}",
  "compare.pageTitle": "Confronto condiviso dei costi dei modelli IA",
  "compare.pageBody": "Confronta tariffe per token, finestre di contesto, funzionalità e costi mensili con le ipotesi salvate in questo URL.",
  "compare.emptyTitle": "Nessun modello in questo confronto",
  "compare.emptyBody": "Scegli due o tre modelli dalla tabella dei prezzi per creare un confronto condivisibile.",
  "compare.start": "Scegli modelli",
  "compare.usage": "Carico di lavoro condiviso",
  "notFound.title": "Pagina non trovata",
  "notFound.body": "La pagina potrebbe essere stata spostata o il modello non è più presente nel catalogo attuale.",
  "guide.kicker": "Guida pratica all'acquisto",
  "guide.title": "Confronta i prezzi delle API IA per il tuo carico di lavoro reale",
  "guide.intro": "La tariffa di input più bassa non comporta sempre la fattura totale più bassa. AgentBuck combina i costi di prompt, prompt in cache e token generati per valutare GPT, Claude, Gemini, DeepSeek, Qwen, Grok e altri modelli sullo stesso carico di lavoro.",
  "guide.inputTitle": "Parti dalla tua distribuzione di token",
  "guide.inputBody": "I chatbot consumano solitamente più input che output. Gli agenti di programmazione e i sistemi di ragionamento possono generare molto più output, cambiando il modello più conveniente.",
  "guide.cacheTitle": "Includi la cache dei prompt",
  "guide.cacheBody": "Prompt di sistema ripetuti e lunghi contesti condivisi possono rendere decisivo il prezzo di lettura della cache. Imposta una quota di cache realistica prima di confrontare i totali mensili.",
  "guide.fitTitle": "Verifica funzionalità e contesto",
  "guide.fitBody": "Il prezzo conta solo se il modello soddisfa i requisiti di contesto, input visivo, ragionamento, output strutturato e chiamate a strumenti.",
  "faq.kicker": "Domande frequenti",
  "faq.title": "Domande sui prezzi dei modelli IA",
  "faq.q1": "Come confronta AgentBuck i prezzi API dei modelli IA?",
  "faq.a1": "AgentBuck normalizza le tariffe standard delle API in tempo reale in dollari per milione di token e separa input, input in cache e output. Include i link alla documentazione dei fornitori per la verifica.",
  "faq.q2": "Quale modello IA ha l'API più economica?",
  "faq.a2": "Non esiste un modello sempre più economico. Dipende dal rapporto tra input e output, dall'uso della cache e dalle funzionalità richieste. Inserisci sopra il tuo utilizzo mensile per ordinare i modelli in base al tuo carico di lavoro.",
  "faq.q3": "Come viene calcolato il costo mensile stimato di un LLM?",
  "faq.a3": "La stima moltiplica i volumi di input senza cache, input in cache e output per le tariffe corrispondenti di ogni modello. Sono esclusi imposte, sconti batch, prezzi regionali e supplementi per contesti lunghi.",
  "faq.q4": "Perché un modello può mostrare un prezzo di zero dollari?",
  "faq.a4": "Alcuni fornitori offrono accesso gratuito o promozionale a modelli specifici. Disponibilità e limiti possono cambiare: verifica la documentazione del fornitore prima dell'uso in produzione.",
  "faq.q5": "Quanto sono aggiornati i dati sui prezzi?",
  "faq.a5": "AgentBuck aggiorna il catalogo strutturato ogni sei ore. La tabella mostra l'aggiornamento dei modelli più recente della fonte, mentre la fatturazione effettiva resta soggetta alle condizioni del fornitore.",
  "method.title": "Dati e metodologia",
  "method.priceTitle": "Base dei prezzi",
  "method.priceBody": "Tariffe standard delle API in tempo reale in USD per milione di token. Sono esclusi imposte, tariffe batch, maggiorazioni regionali e fasce di contesto lungo.",
  "method.sourceTitle": "Fonte dei dati",
  "method.sourceBefore": "I cataloghi pubblici dei modelli e le pagine dei prezzi dei fornitori vengono normalizzati in un insieme di dati confrontabile.",
  "method.sourceAfter": "AgentBuck lo aggiorna ogni sei ore e include i link alla documentazione dei fornitori per la verifica.",
  "method.costTitle": "Stima dei costi",
  "method.costBody": "Costo mensile = input normale + input in cache + output. Usalo per pianificare il budget; il pannello del fornitore è il riferimento ufficiale per la fatturazione.",
  "footer.tagline": "Dai valore a ogni token.",
  "footer.updated": "Dati aggiornati il {date}",
  "compare.selected": "{count}/3 selezionati",
  "compare.remove": "Rimuovi {name}",
  "compare.button": "Confronta modelli",
  "compare.kicker": "Confronto dei modelli",
  "compare.title": "Prezzi e funzionalità a confronto",
  "compare.close": "Chiudi",
  "compare.input": "Input / MTok",
  "compare.cache": "Cache / MTok",
  "compare.output": "Output / MTok",
  "compare.monthly": "Costo mensile stimato",
  "compare.context": "Contesto",
  "compare.capabilities": "Ragionamento / strumenti / visione",
  "compare.docs": "Documentazione del fornitore",
  "compare.viewPrice": "Vedi prezzi",
  "nav.requestCalculator": "Calcolatore di costo per richiesta",
  "home.calculatorTitle": "Stima il costo per volume di richieste",
  "home.calculatorBody": "Calcola la spesa mensile in base alle richieste giornaliere, ai token per richiesta e al tasso di hit della cache.",
  "home.compareDirectoryTitle": "Sfoglia i confronti tra modelli",
  "home.compareDirectoryBody": "Parti da un confronto selezionato o creane uno tuo dalla tabella dei prezzi.",
  "model.formulaTitle": "Formula di costo",
  "model.formulaBody": "Costo mensile = (token di input non in cache × tariffa di input) + (token di input in cache × tariffa di lettura cache) + (token di output × tariffa di output), il tutto per milione di token. Senza una tariffa di lettura cache pubblicata, i token in cache sono stimati alla tariffa di input standard.",
  "model.exampleTitle": "Esempio riproducibile",
  "model.exampleBody": "Esempio: {inputM} token di input ({cachePercent}% serviti dalla cache) e {outputM} token di output costano {total} alle tariffe pubblicate di questo modello — {inputRate} input, {cacheRate} input in cache, {outputRate} output per milione di token.",
  "model.calculatorCta": "Stima il costo in base al volume giornaliero di richieste",
  "model.comparisonsTitle": "Presente in questi confronti selezionati",
};
